import React from 'react'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
// actions
import * as USER_ACTION from '@store/user/actions'
import * as SHARED_ACTION from '@store/shared/actions'

import { Modal, Icon } from '@components/shared/elements'
import MaskedInput from 'react-text-mask'

import TOOLS from '@helpers/tools'
import COOKIES from '@helpers/cookies'
import slugify from 'slugify'
import { isEqual, isEmpty } from 'lodash'

import { handleBlurDatalayer, genericModalDataLayer } from '@helpers/BI'

class ModalCall extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      phone: '',
      shBranchId: '',
      shBranchName: '',
      shBranchModalId: '',
      stateInitials: '',
      typeContactDirt: false,
      nameDirt: false,
      phoneDirt: false,
      periodTime: '',
      blockSending: false,
      success: '',
      error: '',
      hasBranches: false,
      branchSelected: '',
      hasFacilitaMsg: '',
      privacyPolicies: true,
      hasListaFiliais: false,
      singleFilial: false,
      listaFiliaisAtendimento: [],
    }
    this.el = React.createRef()
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.shBranchId === '') {
      if (prevProps.branches.sucess) {
        let sufix = this.props.product.success ? '-ficha-imovel' : ''
        this.setState({
          shBranchId: this.props.branches.codigoFilialPadrao,
          shBranchName: 'Filial Padrão',
          shBranchModalId: this.props.branches.CodigoPadraoIntegracaoLigamos + sufix,
        })
      }
    }

    if (prevState.blockSending !== this.state.blockSending) {
      setTimeout(() => {
        this.setState({
          name: '',
          phone: '',
          shBranchId: '',
          shBranchName: '',
          shBranchModalId: '',
          stateInitials: '',
          typeContactDirt: false,
          nameDirt: false,
          phoneDirt: false,
          periodTime: '',
          blockSending: false,
          success: '',
          error: '',
          hasBranches: false,
          branchSelected: '',
          hasFacilitaMsg: '',
          privacyPolicies: true,
        })
      }, 3000)
    }

    if (prevProps.region !== this.props.region) {
      let stateList = this.props.regions
      if (stateList.success) {
        const busca = await stateList.estados.find(item => +item.IdEstado === +this.props.region)
        const praca = busca.Uf.toLowerCase()
        this.setState({
          stateInitials: `${praca}`,
        })
      }
    }

    const listaFiliaisAtendimento = this.props.branches.listaFiliaisAtendimento
    if (!isEqual(prevState.listaFiliaisAtendimento, listaFiliaisAtendimento)) {
      this.setState({
        listaFiliaisAtendimento: listaFiliaisAtendimento,
        hasListaFiliais: !isEmpty(listaFiliaisAtendimento),
      })
      if (this.state.hasListaFiliais) {
        if (listaFiliaisAtendimento.length === 1) {
          this.setState({ singleFilial: true })
          const item = listaFiliaisAtendimento[0]
          if (this.state.shBranchId !== item.CodigoFilial) {
            this._handleChangeBranch(item)
          }
        } else {
          this.setState({ singleFilial: false })
        }
      }
    }

    if (prevState.shBranchId !== this.state.shBranchId) {
      let dadosFilial = listaFiliaisAtendimento.find(item => item.CodigoFilial === this.state.shBranchId)
      if (!isEmpty(dadosFilial)) {
        if (this.state.shBranchModalId !== dadosFilial.CodigoIntegracaoLigamos) {
          if (this.props.product.success) {
            this.setState({
              shBranchModalId: dadosFilial.CodigoIntegracaoLigamos + '-ficha-imovel',
              shBranchName: dadosFilial.Nome,
            })
          } else {
            this.setState({
              shBranchModalId: dadosFilial.CodigoIntegracaoEmail,
              shBranchName: dadosFilial.Nome,
            })

          }
        }
      }
    }
  }

  _toggleMenu(event) {
    event.preventDefault()
    this.setState({
      showMenuChat: !this.state.showMenuChat,
    })
  }

  handleBranchSelect = async selectedBranch => {
    await this.setState({ branch: selectedBranch })
  }

  _handleChangeBranch(item) {
    this.setState({ branchSelected: item.Nome, shBranchId: item.CodigoFilial })
    if (this.props.product.success) {
      this.setState({
        shBranchModalId: `${this.props.branches.CodigoPadraoIntegracaoLigamos}-ficha-imovel`,
      })
    } else {
      this.setState({
        shBranchModalId: item.CodigoIntegracaoLigamos,
      })
    }
  }

  _enviaMensagem(element) {
    this.setState({ nameDirt: true, emailDirt: true, blockSending: true })

    const integraSomenteMobi = !!this.props.product.imovel && !isEmpty(this.props.product.imovel)
      ? this.props.product.imovel.IntegraSomenteMobi
      : false

    let nome = this.state.name
    let fone = this.state.phone

    let phoneValid = this.state.phoneDirt ? TOOLS.phoneValid(fone) : true

    if (nome !== '' && phoneValid) {
      let region = this.props.region === undefined
        ? this.props.product.imovel.Localizacao.IdEstado
        : this.props.region

      const state = this.props.locations.find(e => +e.idEstado === +this.props.region)
      let values = {
        nome: nome,
        telefone: fone,
        periodo: this.state.periodTime,
        product: this.props.product.imovel,
        highlight: this.props.highlightModal,
        gaSend: COOKIES.getUtmGaSend(),
        regionId: parseInt(region, 10),
        cityId: state.filtroCidade[0].idCidade,
        idLogFacilita: null,
      }

      // São Paulo - Facilita
      if (!integraSomenteMobi && values.regionId === 1) {
        const cidade = this.props.locations.find(item => +item.idEstado === +this.props.region)
        const urlWithoutQuerystring = window.location.href.split('?')[0]

        let payloadFacilita = {}
        payloadFacilita['facilita_custom_page'] = document.title
        payloadFacilita['facilita_custom_url'] = `${urlWithoutQuerystring}?utm_campaign=${values.gaSend.UtmCampaign}&utm_content=${values.gaSend.UtmContent}&utm_medium=${values.gaSend.UtmMedium}&utm_source=${values.gaSend.UtmSource}&utm_term=${values.gaSend.UtmTerm}${!!values.gaSend.UtmGclid ? `&utm_gclid=${values.gaSend.UtmGclid}` : ''}`
        payloadFacilita['facilita_custom_selector'] = this.state.shBranchModalId
        payloadFacilita['name'] = nome
        payloadFacilita['phone'] = fone
        payloadFacilita['email'] = ''
        payloadFacilita['codigo_filial'] = this.state.shBranchId
        payloadFacilita['nome_filial'] = this.state.shBranchName
        payloadFacilita['client_id_ga'] = values.gaSend.CodigoGa
        payloadFacilita['idImovel'] = undefined
        payloadFacilita['empreendimento'] = undefined
        payloadFacilita['cidade'] = cidade.nome
        payloadFacilita['ImovelOrigemId'] = 3
        payloadFacilita['url'] = window.location.href
        payloadFacilita['produto'] = 31

        if (values.product && values.product.imovelId) {
          payloadFacilita['idImovel'] = values.product.imovelId
          payloadFacilita['produto'] = values.product.IdFacilita || 31
          payloadFacilita['empreendimento'] = values.product.Nome
          payloadFacilita['cidade'] = values.product.Localizacao.Cidade
        }

        if (values.highlight && values.highlight.imovelId) {
          payloadFacilita['idImovel'] = values.highlight.imovelId
          payloadFacilita['produto'] = values.highlight.idFacilita || 31
          payloadFacilita['empreendimento'] = values.highlight.imovelNome
          payloadFacilita['cidade'] = values.highlight.imovelLocalizacao
        }

        let logPayload = {
          IdImovelOrigem: 3,
          PontoContato: 5,
          IdentificadorLog: 'E028', //codigo padrão - falha facilita
        }

        this.props.actions.callFacilita(payloadFacilita)
          .then(responseFacilita => {
            logPayload['Descricao'] = `{ "request": ${JSON.stringify(payloadFacilita)}, "response": ${JSON.stringify(responseFacilita)} }`
            if (responseFacilita.status === 'success') {
              logPayload['IdentificadorLog'] = 'I023' // codigo - sucesso facilita
            }
          })
          .catch(erro => {
            logPayload['Descricao'] = `{ "request": ${JSON.stringify(payloadFacilita)}, "response": ${JSON.stringify(erro)} }`
          })
          .finally(() => {
            this.props.actions.recordLog(logPayload).then(response => {
              values['idLogFacilita'] = response.idLog
              this._generateLead(values)
            })
          })
      } else {
        this._generateLead(values)
      }
    } else {
      this.setState({ blockSending: false })
    }

    // GA data
    const elementText = slugify(element.target.innerText, { lower: true })
    genericModalDataLayer(this.props.product.imovel, this.props.locations, this.props.region, 'modal-ligamos-para-voce', elementText)
  }

  _generateLead(values) {
    let jsonBody = {}
    jsonBody['PontoContato'] = 'Ligamos para você'
    jsonBody['Periodo'] = values.periodo
    jsonBody['url'] = window.location.href
    jsonBody['ImovelOrigemId'] = 3
    jsonBody['OrigemContato'] = 3 // Possivel remover? Ajustar Back antes
    jsonBody['EstadoId'] = values.regionId
    jsonBody['CidadeId'] = values.cityId
    jsonBody['Nome'] = values.nome
    jsonBody['Email'] = values.email
    jsonBody['Telefone'] = values.telefone
    jsonBody['IdLog'] = values.idLogFacilita

    if (values.product && values.product.imovelId) {
      jsonBody['IdImovel'] = values.product.imovelId
      jsonBody['NomeEmpreendimento'] = values.product.Nome
    }

    if (values.highlight && values.highlight.imovelId) {
      jsonBody['IdImovel'] = values.highlight.imovelId
      jsonBody['NomeEmpreendimento'] = values.highlight.imovelNome
    }

    Object.assign(jsonBody, values.gaSend)

    this.props.actions.contactUsCall(jsonBody).then(result => {
      this.setState({ success: true })
    }).catch(result => {
      this.setState({ error: true })
    }).finally(() => {
      this.setState({
        nameDirt: false,
        emailDirt: false,
        blockSending: false,
      })
      setTimeout(() => {
        this.setState({ error: false, success: false })
        this.props.close()
      }, 5000)
    })
  }

  render() {
    let blockSending = this.state.blockSending
    let nameValid
    let phoneValid

    if (this.state.nameDirt) {
      nameValid = (this.state.name !== '') ? 'is-valid' : 'has-error'
    }
    if (this.state.phoneDirt) {
      phoneValid = (TOOLS.phoneValid(this.state.phone)) ? 'is-valid' : 'has-error'
    }

    const listaFiliaisAtendimento = this.state.listaFiliaisAtendimento
    const mostrarListaFiliais = this.state.hasListaFiliais && !this.state.singleFilial

    return <Modal show={this.props.show} close={this.props.close} fullscreen={false} goback={(this.props.goback)}>
      <h4 className='h5 mt3 mb2'><strong>Ligamos para você</strong></h4>
      <form onSubmit={(event) => this._handleSubmit(event)} data-ga-name='modal-contato' id={this.state.shBranchModalId}>

        <div className={`field-group mb2 ${nameValid === 'is-valid' && 'is-valid'} ${nameValid === 'has-error' && 'has-error'}`}>
          <label>
            <input className='mb0' type='text' value={this.state.name}
              onChange={(event) => this.setState({ name: event.target.value })}
              onBlur={(e) => {
                handleBlurDatalayer(e, 'name', 'Ligamos para você')
                this.setState({ nameDirt: true })
              }}
              placeholder='Qual é seu nome?'
              maxLength='70' />
            <div className='text-small text-error ml1 mt1'>Qual seu nome?</div>
          </label>
          <span className='icon mr1'>
            <span className='field-icon'>
              <Icon iconType='far' icon='user' size='sm' />
            </span>
            <span className='text-error'>
              <Icon icon='times' size='sm' />
            </span>
            <span className='text-success'>
              <Icon icon='check' size='sm' />
            </span>
          </span>
        </div>

        <div className={`field-group mb3 ${phoneValid === 'is-valid' && 'is-valid'} ${phoneValid === 'has-error' && 'has-error'}`}>
          <label>
            <MaskedInput
              mask={TOOLS.cellphoneMask(this.state.phone)}
              guide={false}
              className='mb0'
              type='tel'
              value={this.state.phone}
              onChange={(event) => this.setState({ phone: event.target.value })}
              onBlur={(e) => {
                handleBlurDatalayer(e, 'phone', 'Ligamos para você')
                this.setState({ phoneDirt: true })
              }}
              placeholder='Qual é o seu telefone (com DDD)?'
            />
            <div className='text-small text-error ml1 mt1'>Seu telefone com DDD</div>
          </label>
          <span className='icon mr1'>
            <span className='field-icon'>
              <Icon icon='phone' size='sm' />
            </span>
            <span className='text-error'>
              <Icon icon='times' size='sm' />
            </span>
            <span className='text-success'>
              <Icon icon='check' size='sm' />
            </span>
          </span>
        </div>

        {this.props.region !== 1 && (
          <div className='custom-radio'>
            <p>Gostaria que me ligassem</p>
            <div className='grid-x'>
              <div className='cell large-5 mb2'>
                <input name='callAgree' id='now-field' type='radio' checked={this.state.periodTimeNow} onChange={() => this.setState({ periodTime: 'Agora' })} />
                <label htmlFor='now-field'>Agora</label>
              </div>

              <div className='cell large-5 mb2'>
                <input name='callAgree' id='afternoon-field' type='radio' checked={this.state.periodTimeAfternoon} onChange={() => this.setState({ periodTime: 'Durante a tarde' })} />
                <label htmlFor='afternoon-field'>Durante a tarde</label>
              </div>

              <div className='cell large-5 mb2'>
                <input name='callAgree' id='morning-field' type='radio' checked={this.state.periodTimeMorning} onChange={() => this.setState({ periodTime: 'Durante a manhã' })} />
                <label htmlFor='morning-field'>Durante a manhã</label>
              </div>

              <div className='cell large-5 mb2'>
                <input name='callAgree' id='evening-field' type='radio' checked={this.state.periodTimeEvening} onChange={() => this.setState({ periodTime: 'Durante a noite' })} />
                <label htmlFor='evening-field'>Durante a noite</label>
              </div>
            </div>
          </div>
        )}

        {mostrarListaFiliais && this.props.region === 1 && (
          <div className={'field-group mb3'}>
            <label>
              <div>
                <button className={`branchListButton ${this.state.showMenuChat ? 'active' : ''}`} onClick={(event) => this._toggleMenu(event)}>
                  <span>{this.state.branchSelected ? this.state.branchSelected : 'Selecione a loja mais próxima'}</span>
                </button>
                {this.state.showMenuChat &&
                  <ul className='branchList'>
                    {listaFiliaisAtendimento.map((item, index) => {
                      let siglaEstado = item.siglaEstado.toUpperCase()
                      return (
                        <li key={item.Id} className={this.state.branchSelected === item.Nome ? 'selecionado' : ''}>
                          <button
                            onClick={
                              (event) => {
                                this._toggleMenu(event)
                                this._handleChangeBranch(item)
                              }
                            }
                          >
                            <span className='icon hover hidden'>
                              <Icon icon='check' size='sm' />
                            </span>
                            <span><strong>{item.Nome}</strong></span>
                            <span>{item.Rua}, {item.Numero} - {item.nomeBairro}, {item.nomeCidade} - {siglaEstado}</span>
                          </button>
                        </li>
                      )
                    })}
                  </ul>
                }
              </div>
              <div className='text-small text-error ml1 mt1'>Preencha a loja mais próxima, por favor</div>
            </label>
            <span className='icon mr1'>
              <span className='field-icon'>
                <Icon icon='chevron-down' size='sm' />
              </span>
              <span className='text-error'>
                <Icon icon='times' size='sm' />
              </span>
              <span className='text-success'>
                <Icon icon='check' size='sm' />
              </span>
            </span>
          </div>
        )}

        <div className={'mt3'}>
          <label htmlFor='privacy-field-newsletter'>Prezamos pela privacidade e a coleta dos seus dados pessoais atenderá as diretrizes da legislação aplicável. Para mais informações, acesse nosso{' '}
            <a href='/termos-privacidade' title='Aviso de Privacidade' target='_blank' rel='noreferrer noopener'>Aviso de Privacidade</a>
          </label>
        </div>

        <button className='button info min-width mt3' type='button' disabled={blockSending} onClick={e => this._enviaMensagem(e)} data-ga-status>{blockSending ? 'Enviando...' : 'Solicitar informações'}</button>

        {this.state.success &&
          <div className='callout success text-center mt4 mb0'>
            <p>Suas informações foram enviadas com sucesso.</p>
          </div>
        }

        {this.state.error &&
          <div className='callout alert text-center mt4 mb0'>
            <p>Não foi possível realizar a sua solicitação, tente mais tarde.</p>
          </div>
        }

      </form>
    </Modal>
  }
}
const mapStateToProps = state => {
  return {
    currentUser: state.user.currentUser,
    product: state.products.product,
    region: state.shared.region,
    regions: state.shared.regions,
    highlightModal: state.shared.highlightModal,
    shBranchId: state.shared.shBranchId,
    locations: state.locations.estados,
    branches: state.shared.regionBranches,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...USER_ACTION,
      ...SHARED_ACTION,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCall)



// WEBPACK FOOTER //
// ./src/components/children/contactForm/ModalCall.js